import { formatIsoDate } from '@front-activerse/common-components';
import { RedirectRoute } from '../Routing/types';
import * as PATHS from './paths';

const dayPlanPath = `${PATHS.PATH_DAY_PLAN_INDEX}/${formatIsoDate(new Date())}`;

const redirects: RedirectRoute[] = [
  {
    path: '/',
    redirectTo: dayPlanPath,
  },
  {
    path: PATHS.PATH_DAY_PLAN_INDEX,
    redirectTo: dayPlanPath,
  },
  {
    path: `${PATHS.PATH_DAY_PLAN_INDEX}/shopping-list`,
    redirectTo: `${PATHS.PATH_DAY_PLAN_INDEX}/module/shopping-list`,
  },
  {
    path: `${PATHS.PATH_DAY_PLAN_INDEX}/favourite-meals`,
    redirectTo: `${PATHS.PATH_DAY_PLAN_INDEX}/module/favourite-meals`,
  },
];

export default redirects;
